function BioService($q, AppSettings, AuthService, CommonService) {
  'ngInject';

  const service = {};

  // 생체 정보 조회(선수가 입력한 데이터)
  service.userData = function(params) {
    const url = AppSettings.apiUrl.restRoot + 'bio/user_data';

    return CommonService.post(url, params);
  };

  // 건강기록 - 선수목록 조회(해당선수 모든 건강기록 데이터 포함)
  service.healthDataList = function(params) {
    const url = AppSettings.apiUrl.restRoot + 'bio/health';

    return CommonService.post(url, params);
  };

  // 생체 정보 조회(기록분석 시 사용: 4가지 항목 한꺼번에 열람)
  service.userDataAll = function(params) {
    const url = AppSettings.apiUrl.restRoot + 'bio/user_data_all';

    return CommonService.post(url, params);
  };

  // 생체 정보 입력
  service.userInput = function(params) {
    const url = AppSettings.apiUrl.restRoot + 'bio/user_input';

    return CommonService.post(url, params);
  };

  // 디바이스로 부터 입력된 생체 정보 입력
  service.deviceInput = function(params) {
    const url = AppSettings.apiUrl.restRoot + 'bio/device_input';

    return CommonService.post(url, params);
  }

  // 디바이스로 부터 입력된 생체 정보 조회
  service.deviceData = function(params) {
    const url = AppSettings.apiUrl.restRoot + 'bio/device_data';

    return CommonService.post(url, params);
  }

  // 목표치 입력
  service.setTarget = function(params) {
    const url = AppSettings.apiUrl.restRoot + 'bio/set_target';

    return CommonService.post(url, params);
  };

  // 패턴조회
  service.patterns = function (params) {
    const url = AppSettings.apiUrl.restRoot + 'bio/patterns';

    return CommonService.post(url, params);
  };

  // 생체 정보 조회
  service.userData2 = function (params) {
    const url = AppSettings.apiUrl.restRoot + 'bio/user_data2';

    return CommonService.post(url, params);
  };

  return service;

}

export default {
  name: 'BioService',
  fn: BioService
};
